import styles from "./proprietyOthers.module.css";
import Link from "next/link";
import dynamic from "next/dynamic";


const ProprietyCard = dynamic(() => import("components/ProprietyCard"), {
  ssr: false
}) 

export default function ProprietyOthers({ data, cidade }) {
  return (
    <>
      <section id="destaque" className={styles.container}>
        <div className={"grid-cont flex-column"}>
          <div className={styles.title}>
            <div className="d-flex">
              <div className={styles.parallelogramDetail} />
              <h2>
                <strong>Outros imóveis </strong>
                em {cidade}
              </h2>
            </div>
            <Link href="/imoveis">
              <a className={styles.link}>
                <span>Ver todos</span>
                <div>
                  <img src="/icons/arrow-right-red.svg" width={24} height={14}/>
                </div>
              </a>
            </Link>
          </div>
        </div>
      </section>
      <div className={`container-full ${styles.lista}`}>
        <div className={"grid-cont "}>
          <div className={`${styles.listaInner}`}>
            {data.map((item) => (
              <div key={item.id} className={styles.card}>
                <ProprietyCard data={item} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
